<template>
  <Control class="cx_checkbox" :title="title" :isEdit="isEdit && enabled"  :height="36 + (isEdit&&enabled?rows - 1:0 ) * 25" :validator="validator" :provider="editor ? editor.owner:null"  :isDirectEditEnabled="isDirectEditEnabled"   :editor="editor"   :enabled="enabled"  :tooltip="tooltip"  :key="title"  :required="required">
    <template slot="read">{{caption}}</template>
    <template slot="edit">
      <!-- <b-form-checkbox v-model="internalValue" size="sm">{{trueCaption}}</b-form-checkbox> -->

      <b-form-group>
        <b-form-checkbox-group v-model="internalValue" :state="validator.isInvalid? false : null" :options="options"></b-form-checkbox-group>
      </b-form-group>      
      <!-- 新規追加用ダイアログ -->
      <b-modal class="dialog" v-model="showDialog" v-if="showDialog" title="注意事項" :ok-only='true' :no-close-on-backdrop="true" centered>
        <span>{{alertMessage}}</span>
      </b-modal>          
    </template>
  </Control>
</template>
<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import { BindItem } from '../common/formatter';

@Component
export default class CheckBox extends Vue  implements Components.IControl {
  @Prop({default:''}) public title: string;
  @Prop({default:0}) public value: number;
  @Prop({default:''}) public list: string;
  @Prop({default:''}) public disabledList: string;
  @Prop({ default: false }) public required: boolean;
  @Prop({default:null}) public editor :Components.IEditor;
  @Prop({default:true}) public enabled: boolean;
  @Prop({ default: true }) public isDirectEditEnabled: boolean;  
  @Prop() public tooltip: string;
  @Prop({ default: 1 }) public rows: number;
  @Prop() public alertValue: number;  
  @Prop() public alertMessage: string;

  public defaultValue :any = 0; //0かfalseを保持する
  public isEdit: boolean = true;
  public validator: Components.ControlValidator = null ;
  
  public isMounted:boolean = false;

  public showDialog:boolean = false;
  created(){
    this.validator = new Components.ControlValidator(this, 'tooltip', this.internalValidate);
    if (this.editor != null) this.editor.addControl(this);
    //単独ロードもしくはlistViewによるリロード待ち
    if (this.list) this.$api.formatter.ensureListLoaded(this.list).then(()=>{
      this.defaultValue = this.$api.formatter.getOptions(this.list).find(obj=>obj.value ==0).value;
      this.$forceUpdate();
    });     
    // var defaultOption =  this.$api.formatter.getOptions(this.list).find(obj=>obj.value ==0);
    // this.defaultValue = defaultOption ? defaultOption.value: 0;
  }
  destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
  }
  mounted(){
    this.isMounted = true;
  }
  @Watch('value')
  public onValueChanged(){
    if (this.isMounted && this.alertMessage && this.value == this.alertValue) this.showDialog=true;
    else this.showDialog=false;
  }

  public internalValidate(): string {
    if (this.required && this.value == this.defaultValue){
      return '必須項目です。';
    }
    return '';
  }
  /**booleanもしくはenumをバインドすることができます。 */
  public get options(): BindItem[] {
    let disabledTextArray =  this.$api.formatter.getOptions(this.disabledList).map(obj => obj.text);
    const results: any[] = new Array();
    for (const option of this.$api.formatter.getOptions(this.list)) {
      //falseもしくは0の項目は選択肢としては表示しない(ReadOnlyのみで使用する)
      if (option.value != 0) results.push({ text: option.text, value: option.value, disabled: disabledTextArray.includes(option.text)});
    }
    return results;
  } 

  public get internalValue(): Array<number> {
    //enumを配列に変換
    var result = Array();
    this.options.forEach(item =>{
      if ( (this.value &  (item.value as number))  != 0 ) result.push(item.value);
    });
    return result;
  }

  public set internalValue(value: Array<number>) {
    //booleanで連携されている場合は選択結果は一つしかない点に着目
    if (value.length == 0) {
      this.$emit('update:value', this.defaultValue);
    } else if (value.length == 1) {
      this.$emit('update:value', value[0]);
    } else {
      //配列をenum(数値)に変換
      var result = 0;
      value.forEach(item => result = result | (item as number));
      // 親コンポーネント側で更新
      this.$emit('update:value', result);
    }
    this.$emit('changed');
    this.validator.update();
  }

  // get trueCaption(): string {
  //   return this.$api.formatter.formatByList(true, this.list);
  // }

  get caption(): string {

    var result = Array();    
    //未指定時のオプションが必要なので取りなおす
    this.$api.formatter.getOptions(this.list).forEach(item =>{
      if ( (this.value &  (item.value as number))  != 0 ) result.push(item.text);//選択時のキャプション
      else if (this.value == 0 && item.value == 0) result.push(item.text); //未選択時のキャプション
    });

    if (result.length == 0) return  '(未選択)';　//未選択時のキャプションが未指定の場合
    return result.join(' / ');
    // return this.$api.formatter.formatByList(this.value, this.list);
  }


}
</script>
<style lang="scss">
.cx_checkbox{
  .b-form-group {
    margin-bottom: -3px;
  }
}

</style>